// extracted by mini-css-extract-plugin
export default {"logoSection":"LogoSection_logoSection__6zVl4","logo":"LogoSection_logo__5Rnkv","proButton":"LogoSection_proButton__7tNHd"};